import client, { unwrap } from "./client"

export async function login({ email, password }) {
  const payload = { email: email.trim().toLowerCase(), password }
  const response = await client.post("/user/login/", payload)
  return unwrap(response)
}

export async function fetchRestaurants() {
  const response = await client.get("/user/restaurants/", { params: { lite: false } })
  return unwrap(response) ?? []
}

// There is deliberately no server-side logout here. /user/logout/ drops every session
// the user has, which would sign them out of the native app too; the native app itself
// only clears its local credentials on logout, so the PWA matches that.
